import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { EasypayImportFile } from './easypay-import-file.interface';

export class EasypayImportFileService {
   async getEasypayImportFiles(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<EasypayImportFile>>(`/easypay-import-files`, {
         params: { ...query, append: 'scopes' },
      });
      return response.data;
   }

   async getEasypayImportFileUrls(ids: Array<number>) {
      const response = await http.get(`easypay-import-file-urls`, { params: { easypay_import_file_id: ids.join(',') } });
      return response.data;
   }

   async patchEasypayImportFile(importFileId: number, body: any) {
      return await http.patch<EasypayImportFile>(`/easypay-import-files/${importFileId}`, body).then((response) => response.data);
   }

   async getEasypayImportFileCouples(query?: LocationQuery) {
      const response = await http.get(`/easypay-import-file-couples`, { params: { ...query, append: 'scopes' } });
      return response.data;
   }

   async getEasypayImportErrorFileUrls(errorFileIds: Array<number>) {
      const response = await http.get(`/easypay-import-error-file-urls?easypay_import_error_file_id=${errorFileIds.join(',')}`);
      return response.data;
   }
}
